import Switch from "components/Common/Switch";
import {MENU_TYPE, MENU, menus} from "../list";
import styles from "./index.module.scss";

export default function View({menuType, isAdmin, isAutoSaveOn, isHelperOn, onClickMenu, onClickAutoSave, onClickHelperToggle, version}) {
  const menu = menus[menuType];

  return (
    <ul className={styles.container}>
      {menu.map(item => {
        return (
          <li key={item.name} onClick={() => onClickMenu(item?.type)}>
            <div>
              <span className={`${menuType === MENU_TYPE.HELP ? styles.hyperlink : ""}`}>{item.name}</span>
              <p className={styles.description}>{item.description}</p>
            </div>
          </li>
        );
      })}
      {menuType === MENU_TYPE.FILE && (
        <>
          <div className={styles.divider} />
          <li>
            <p>Helper</p>
            <Switch checked={isHelperOn} onChange={onClickHelperToggle} />
          </li>
          <li>
            <p>Auto Save</p>
            <Switch checked={isAutoSaveOn} onChange={onClickAutoSave} />
          </li>
          <li>
            <p>version {version.slice(1)}</p>
          </li>
        </>
      )}
    </ul>
  );
}
